import { createNamedContext } from '@core/createNamedContext'

export interface TranslatorContextValue {
  loading: boolean
  translations: Record<string, string>
}

export const TranslatorContext = createNamedContext<TranslatorContextValue>(
  'TranslatorContext',
  null
)
